import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./employerPortal.css";

export default function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const userId = location.state?.userId;
  const userType = location.state?.userType;

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!userId || !userType) {
      alert("Missing user details. Please log in again.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      alert("New passwords don't match.");
      return;
    }

    try {
      await AxiosInstance.post(`companies/change-password/`, {
        user_id: userId,
        user_type: userType,
        current_password: currentPassword,
        new_password: newPassword,
      });

      alert('Password changed successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
      navigate(-1);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.detail || 'Failed to change password.');
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal d-block als-employer-page"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="changePasswordLabel"
        style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="changePasswordLabel">
                Change Password
              </h5>
            </div>

            <div className="modal-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
              <form onSubmit={handleChangePassword}>
                <div className="mb-3">
                  <label htmlFor="currentPassword" className="form-label">
                    Current Password
                  </label>
                  <input
                    id="currentPassword"
                    type="password"
                    className="form-control"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">
                    New Password
                  </label>
                  <input
                    id="newPassword"
                    type="password"
                    className="form-control"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="confirmNewPassword" className="form-label">
                    Confirm New Password
                  </label>
                  <input
                    id="confirmNewPassword"
                    type="password"
                    className="form-control"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" className="btn btn-secondary" onClick={closeModal}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Change Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
